import { useOutletContext } from "react-router-dom";

export function useIsPageLoading() {
  return useOutletContext<OutletContextType>();
}

export type OutletContextType = {
  isPageLoading: boolean;
  setIsPageLoading: (setIsPageLoading: boolean) => void;
};
